/**
 * Permet de récupérer un paramètre dans l'URL
 *
 * @param   paramName                   nom du paramètre
 * @param   forceLowercaseComparison    Permet de forcer la comparaison de la clé en minuscule
 * Si ce paramètre est utilisé paramName et les clés du tableau des paramètres seront converti en minuscule
 * @returns {string|boolean}            retourne la valeur du paramètre ou false s'il n'existe pas
 */
export function PageParametre (paramName, forceLowercaseComparison = true) {

    const URLObject = new URL(window.location.href) // Création d'un objet URL
    const URLSearchParams  = URLObject.searchParams; // Objet URLSearchParams

    // Force à tout comparer en minuscule
    if(forceLowercaseComparison)
    {
        paramName = paramName.toString().toLowerCase()

        // Parcourt du tableau pour ajouter toutes les clés en minuscule
        URLSearchParams.forEach((value, key) =>
        {
            URLSearchParams.set(key.toLowerCase(), value);
        })
    }

    // Si le paramètre n'existe pas, retourne faux
    if(!URLSearchParams.has(paramName))
    {
        return false;
    }

    // Retourne le paramètre
    return decodeURIComponent(URLSearchParams.get(paramName));
}

// Ancienne version ici
// function PageParametre(key,url)
// {
//
//     //Récupère l'adresse de la page
//     if(!url) url = document.location.href;
//
//     //On se positionne sur le paramètre demandé
//     pos1=url.indexOf("&"+key+"=",1);
//     if(pos1<0)
//     {
//         //Si il n'est pas trouvé avec '&' c'est que c'est le premier
//         //Paramètre indiqué
//         pos1=url.indexOf("?"+key+"=",1);
//         if(pos1<0)
//             //Sinon il s'agit d'une ancre
//             pos1=url.indexOf("#"+key+"=",1);
//         if(pos1<0)
//             // Si il n'y a aucun paramètre
//             return "";
//     }
//
//     //On récupère la longueur du paramètre indiqué
//     lg1=key.length;
//     //Puis on recupère la fin de déclaration du paramètre dans l'URL
//     pos2=url.indexOf("&",pos1+1);
//
//     if(pos2>0)
//         //On récupère la valeur du paramètre
//         return url.substring(pos1+lg1+2,pos2);
//     else {
//         pos2=url.indexOf("#",pos1+1);
//         if(pos2>0)
//             //On récupère la valeur du paramètre
//             return url.substring(pos1+lg1+2,pos2);
//         else
//             //On récupère la valeur du paramètre
//             return url.substring(pos1+lg1+2,url.length);
//     }
// }
